import React from 'react'
import css from '@emotion/css'
import styled from '@emotion/styled'
import JustinsFace from './JustinsFace'
import { getEmSize } from '../../../styles/mixins'
import { widths, colors, breakpoints } from '../../../styles/variables'

const Container = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: auto;
  padding-right: 40px;
  align-items: stretch;
  position: relative;
  height: 550px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    padding: 0;
    flex-direction: column;
    height: 530px;
  }
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 550px;
  width: 100%;
  background: ${colors.lightBlue};
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    height: 530px;
  }
`

const JustinsFaceContainer = styled.div`
  width: 60%;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    width: 100%;
    height: 100%;
    padding: 0;
  }
`

const ContentContainer = styled.div`
  width: 70%;
  position: absolute;
  right: 50px;
  bottom: 100px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    width: 90%;
    right: 0;
    left: 20px;
    top: 0px;
  }
`

const Title = styled.h1`
  color: ${colors.darkBlue};
  font-size: 90px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    font-size: 50px;
    margin-top: 20px;
  }
`

const StyledP = styled.p`
  max-width: 730px;
  margin-top: 30px;
  color: ${colors.white};
`

export default function Hero() {
  return (
    <Container>
      <Overlay />
      <JustinsFaceContainer>
        <JustinsFace style={{ width: '100%', height: '100%' }} objectPosition="0% 100%" objectFit="contain" />
      </JustinsFaceContainer>
      <ContentContainer>
        <Title>We Can Do This Together.</Title>
        <StyledP>
          Our democracy, economy, and environment are all in crisis—we can’t expect help from the same politicians who led us here. We need
          ambitious, bold action that matches the scale and urgency of these crises.
        </StyledP>
        <StyledP>We need new leaders who have the courage to step up and join the conversation to reimagine entire systems.</StyledP>
      </ContentContainer>
    </Container>
  )
}
